import * as React from 'react';
const CapelliSecchiEDanneggiatiIcon = ({
  primaryColor,
  secondaryColor,
  width,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M105.06 115.75c-.64-40.26 6.32-63 6.32-63-17.5 25.52-17.5 76.56-17.5 76.56 0 6.04 2.61 10.94 5.83 10.94s5.83-4.9 5.83-10.94c-.12-2.23-.22-4.42-.3-6.56"
      className="prefix__cls-1"
    />
    <path
      d="M77.25 115.75h6.46c2.01 0 3.6 1.7 3.49 3.7-.31 5.63-.33 9.31-.33 9.86 0 10.39 5.39 17.94 12.83 17.94s12.84-7.54 12.84-17.94l-.02-.39c-.18-3.29-.31-6.48-.39-9.58a3.507 3.507 0 0 1 3.5-3.6h19.36M65 115.75h5.25"
      className="prefix__cls-2"
    />
    <path
      d="M112.21 99.78c1.35 1.08 2.14 2.35 2.14 3.72 0 3.87-6.27 7-14 7s-14-3.13-14-7c0-1.57 1.03-3.02 2.78-4.19M113.47 81.57c.79.81 1.23 1.72 1.23 2.68 0 3.38-5.48 6.12-12.25 6.12S90.2 87.63 90.2 84.25c0-1.37.91-2.64 2.43-3.66M115.87 64.59c.6.66.93 1.39.93 2.16 0 2.9-4.7 5.25-10.5 5.25s-10.5-2.35-10.5-5.25c0-1.2.8-2.3 2.16-3.19"
      className="prefix__cls-1"
    />
  </svg>
);
export default CapelliSecchiEDanneggiatiIcon;
